import { render } from "./coming-soon.vue?vue&type=template&id=5f1a7a64"
import script from "./coming-soon.vue?vue&type=script&lang=js"
export * from "./coming-soon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__